// extracted by mini-css-extract-plugin
module.exports = {"topbarWrapper":"Topbar_topbarWrapper__Wdp6u","pageTitle":"Topbar_pageTitle__2fUfD"};